<template>
  <div class="group-input col-12 row q-mt-sm">
    <label for="type-os">Número da OS</label>
    <q-input
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      color="red-9"
      use-input
      fill-input
      input-debounce="0"
      v-model="requestData.osNumber"
      mask="##########"
      placeholder="Digite aqui"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <div class="group-input col-12 row q-mt-sm">
    <label for="type-os">Tipo de OS</label>
    <q-select
      id="type-os"
      class="col-12 q-mt-sm form-tabulacao"
      outlined
      dense
      ref="typeOSRef"
      v-model="requestData.typeOS"
      color="red-9"
      use-input
      hide-selected
      placeholder="Selecione"
      fill-input
      input-debounce="0"
      @filter="getTypeOsByClassification"
      :options="listTypeOs"
      option-value="value"
      option-label="text"
      bg-color="white"
      lazy-rules
      :rules="[(val) => !!val || 'Campo Obrigatório']"
    />
  </div>
  <div
    class="group-input col-12 row q-mt-md"
  >
    <RequiredLabel title="Observação" name="observation"/>
    <div class="col-12 row flex justify-around">
      <q-input
        v-model="requestData.observation"
        class="col-12 q-mt-sm"
        bg-color="white"
        color="red-9"
        maxlength="120"
        outlined
        type="textarea"
        dense
        placeholder="Digite até 120 caracteres..."
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import { filterListByText } from "@/helpers/filterHelper";
import { computed, ref } from "vue";

  export default {
    name: "DefaultForm",
    components: {
      RequiredLabel,
    },
    props: {
      requestData: Object,
      typeOs: String,
      optionsItens: Object,
    },

    setup(props, { emit }) {
      const numericalTypeOs = computed(() => {
        return Number(props.typeOs);
      });

      const listTypeOs = ref(props.optionsItens.optionsTypeOS);

      function getTypeOsByClassification(val, update) {
        update(() => {
          listTypeOs.value = filterListByText(
            props.optionsItens.optionsTypeOS,
            val,
            "text"
          );
        });
      }

      return {
        numericalTypeOs,
        listTypeOs,
        getTypeOsByClassification,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .section-service {
    width: 100%;

    .panel-services {
      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
</style>
